module.exports = __webpack_public_path__ + "static/media/SolidMenMandarinCollarWhiteBlackTShirt.23302418.jpeg";